// extracted by mini-css-extract-plugin
export default {"componentWrapper":"OffersPeriodic_componentWrapper__BTFZV","header":"OffersPeriodic_header__WESnz","searchFormWrapper":"OffersPeriodic_searchFormWrapper__rhQSB"};